<template>
<div class="loginPage">
  <div class="header">
	<div class="header-layout">
		<h1 class="logo" id="logo">
			<a href="http://www.ddzzii.com"></a>
		</h1>
		<a class="header-text"> 登 录 </a>
	</div>
  </div>
  <div class="container">
    <div class="main">
	  <div class="login-left-box">
		  <a href="">
			<div class="login-left-img">
			</div>
		  </a>
	  </div>
      <div class="login-box">
        <el-tabs v-model="tabsActiveName">
          <el-tab-pane label="账号密码登录" name="username">
            <div class="login-form-box">
              <div class="input-row form-title">密码登录</div>
              <div class="input-row" v-show="loginError!=''">
                <div class="errmsg"><i class="el-icon-warning err-icon"></i>{{ loginError }}</div>
              </div>
              <div class="input-row">
                <el-input v-model.trim="username" placeholder="手机号码/邮箱"></el-input>
              </div>
              <div class="input-row">
                <el-input v-model="password" type="password" placeholder="请输入登录密码"></el-input>
              </div>
              <div class="input-row">
                <verify-image v-model="refreshVerify" :form-key="formKey" @change="code=$event"></verify-image>
              </div>
              <el-button type="primary" style="width: 100%" @click="loginHandler">登录</el-button>
              <div class="login-other-btns">
                <!-- <a href="/checkphone" class="other-link">忘记密码</a> -->
                <router-link :to="{name: 'CheckPhone'}" class="other-link">忘记密码</router-link>
                <router-link :to="{name: 'Register'}" class="other-link">免费注册</router-link>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
  <footer-layout></footer-layout>
</div>
</template>

<script>
  import FooterLayout from '@/components/layout/FooterLayout'
  import VerifyImage from '@/components/fields/VerifyImage'
  import redirect from '@/utils/redirect'

  export default {
    name: 'Login',
    components: {FooterLayout, VerifyImage},
    data() {
      return {
        refreshVerify: false, // 刷新图片验证码
        tabsActiveName: 'username',
        username: '',
        password: '',
        formKey: '',
        code: '',
        loginError: '',
      }
    },
    methods: {
      /**
       * 登录
       */
      loginHandler() {
        // 非空验证
        if (this.username === '') {
          this.loginError = '请输入用户名'
          return
        }
        if (this.password === '') {
          this.loginError = '请输入密码'
          return
        }
        if (this.code === '') {
          this.loginError = '请输入验证码'
          return
        }
        // 验证码验证
        this.$api.common.verifyImgCode(this.formKey, this.code).then(res => {
          console.log(res)
          if (res.data === false) {
            this.loginError = '验证码错误'
            this.refreshVerify = true
            return
          }
        })
        // 登录
        this.$api.user.login(this.username, this.password, this.code, this.formKey).then(res => {
          if (res.code !== 0) {
            this.refreshVerify = true
            this.loginError = res.msg
            return
          }
          console.log(res)
          // 登录成功
          // 1. 设置token 信息
		  this.$cookies.set('token', res.data.token, 0, '/', this.$G.cookieDomain)
          localStorage.setItem('token', res.data.token)
          // 1.2 保存用户信息
          this.$api.user.getUserInfo().then(res1=> {
            console.log(res1)
            localStorage.setItem(this.$G.keys.usernameKey, res1.data.user_info.phone)
            localStorage.setItem(this.$G.keys.userIDKey, res1.data.user_info.uuid)
			localStorage.setItem(this.$G.keys.userIconKey, res1.data.user_info.profile)
            // 2. 跳转回redirect_uri
            location.href = sessionStorage.getItem(this.$G.keys.redirectURIKey)
          })
        })

      },
      /**
       * 验证token
       */
      checkToken() {
        let refreshToken = this.$cookies.get('refresh_token')
        // 没有refresh token 表示没有登录， 不需要验证
        if (refreshToken != null) {
          this.$api.user.checkToken().then(res => {
            if (res.code === 0) {
              location.href = sessionStorage.getItem(this.$G.keys.redirectURIKey)
            }
          })
        }
      },
    },
    created() {
      // 获取redirect_uri 保存
      redirect.redirectURIInit(this.$route.query.redirect_uri)
      // 保存appid
      let appid = this.$route.query.appid
      localStorage.setItem(this.$G.keys.appIDKey, appid)
      // 验证是否已登录
      // this.checkToken()
      // 获取form key
      this.$api.common.formKey().then(res => {
        if (res.code === 0) {
          this.formKey = res.data
        }else{
          console.log(res)
          this.$message.error(res.msg)
        }
      })
    },
  }
</script>

<style scoped>
.loginPage{
	background-color: #F6F6F8;;
}
.loginPage .header {
	width: 100%;
	height: 100px;
	border-bottom: 1px solid #e3e3e3;
	background-color: #fff;
}
.loginPage .header-text{
	text-align: left;
	    font-size: 24px;
	    color: #181818;
	    letter-spacing: 0;
	    display: inline-block;
	    padding: 0 10px;
	    vertical-align: bottom;
	    border-left: 1px solid #999;
	    position: absolute;
}
.loginPage .container {
	min-height: 80vh;
}
  .main {
    min-height: 650px;
	max-height: 800px;
  }
  .login-left-box{
	width: 580px;
	height: 560px;
	position: absolute;
	left: 10px;
	top: 50px;
  }
  .login-left-box > a{
  }
  .login-left-box .login-left-img {
	  height: 560px;
	  background: url(../assets/event.png);
	  background-repeat:no-repeat;
	  background-position-x:105%;
	  background-position-y:50%;
  }
  .login-box {
    width: 600px;
    height: 560px;
    position: absolute;
    right: 10px;
    top: 50px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: #ccc 0 0 10px 1px;
  }

  .login-form-box {
    width: 330px;
    top: 120px;
    margin: 40px auto 0;
    /*border: 1px solid #3a8ee6;*/
  }

  .input-row {
    margin-bottom: 25px;
  }

  .form-title {
    font-size: 20px;
  }

  .login-other-btns {
    text-align: right;
    font-size: 14px;

    margin-top: 15px;
  }

  .other-link, .other-link:hover {
    margin-left: 15px;
    color: #aaa;
    text-decoration: none;
  }

  .errmsg {
    border: 1px solid #ff934c;
    font-size: 12px;
    padding: 5px;
    background-color: #fff8d9;
  }

  .err-icon {
    font-size: 19px;
    color: #ff934c;
    vertical-align: middle;
    margin-right: 5px;
  }
.Indexfooter{
	width: 1200px;
	margin: 30px auto 10px;
	padding-top: 20px;
	border-top: #666 solid 1px;
	color: #666;
	font-size: 14px;
	text-align: center;
}
.footer-first-line{
	margin-bottom: 20px;
}
.footer-first-line div{
	margin: 0 5px;
	display: inline-block;
}
.twohuateng {
	color: #666;
}
</style>
<style>
	.login-form-box .el-input__inner{
		border-radius: 0px;
	}
  .login-box .el-tabs__nav-scroll {
    height: 55px;
    line-height: 55px;
  }

  .login-box .el-tabs__nav, .login-box .el-tabs__active-bar {
    padding: 0 20px;
  }

  .login-box .el-tabs__item {
    font-size: 16px;
  }
</style>
